var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}}),_c('el-container',[_c('el-header',[_c('HeadView')],1),_c('el-main',{staticClass:"main-wrap"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }